import React from "react";
import BannerImage from "../assets/images/banner2.png";
import { FaCheck, FaChartBar, FaUsers } from 'react-icons/fa';

const Banner = () => {
  return (
    <>
      <div className="container-fluid banner-cnt">
        <div className="row">
          <div className="col-md-7 col-12 col-sm-12 col-lg-7 banner-left" data-aos="zoom-in">
            <h1 className="banner-h1">
              <span className="highlight-text"> Decoding </span> software; empowering developers with <span className="highlight-text"> code intelligence </span>
            </h1> 
            <p className="banner-p">
              DCode is a developer analytics platform that transforms your team's productivity data and code quality metrics into actionable visual insights. Track code health, monitor project progress, and make data-driven engineering decisions—all from a single, unified dashboard.
            </p>

            <div className="buttons">
              <a href="/signup">  <button className="btn btn-lg signup-btn">
                Join For Free
              </button> </a>

            </div>

            <div className="row banner-feature-row">
              <div className="col-md-4 col-12 col-sm-12 col-lg-4">
                <div className="feature-box">
                  <div className="feature-header">
                    <div className="feature-icon feature-icon-green">
                      
                      <FaChartBar />
                    </div>
                    <div>
                      <h4 className="banner-feature-h4">Visualize Code Quality</h4>
                      <p className="text-muted banner-feature-p">Interactive Dashboards</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 col-sm-12 col-lg-4">
                <div className="feature-box">
                  <div className="feature-header">
                    <div className="feature-icon feature-icon-blue">
                      <FaCheck />
                    </div>
                    <div>
                      <h4 className="banner-feature-h4">Multi-language Support</h4>
                      <p className="text-muted banner-feature-p">Java, Python, C#</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 col-sm-12 col-lg-4">
                <div className="feature-box">
                  <div className="feature-header">
                    <div className="feature-icon feature-icon-purple">
                      <FaUsers />
                    </div>
                    <div>
                      <h4 className="banner-feature-h4">Team Collaboration & Analytics</h4>
                      <p className="text-muted banner-feature-p">Built for teams</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="col-md-5 col-12 col-sm-12 col-lg-5" data-aos="zoom-in">
            <img src={BannerImage} className="banner-img" />
          </div>
        </div>

      </div>
    </>
  );
};

export default Banner;